const directionData = {
    directionLayer: {
        id: 'dir',
        type: 'line',
        source: {
            type: 'geojson',
            data: {
                type: 'Feature',
                geometry: []
            }
        },
        'layout': {
            'line-join': 'round',
            'line-cap': 'round'
        },
        paint: {
            'line-width': 5,
            'line-color': '#036ff4'
        }
    },
    locationMarkers : {
        type: 'FeatureCollection',
        features: [
            {
                type: 'Feature',
                geometry: {
                type: 'Point',
                    coordinates: []
                },
                properties: {
                    id: 'uaeu-start'
                }
            },
            {
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: []
                },
                properties: {
                    id: 'uaeu-end'
                }
            }
        ]
    },
    markerLayer : {
        "id": "",
        "type": "symbol",
        "source": {
            "type": "geojson",
            "data": []
        },
        "layout": {
            "icon-image": "point",
            "icon-size": 1,
            "icon-allow-overlap": false,
            "icon-anchor" : "bottom",
            "icon-offset" : [0, 0]
        }
    }
};

export default directionData;


// WEBPACK FOOTER //
// ./src/utils/Direction.js